import { CircleCheck, CircleX, Loader2, Info } from "lucide-react";
import { euro } from "@/hooks/useQuote";

export const QuoteSummary = ({ quote, error, loading, testId = "quote-summary", dark = false }) => {
  const base = `flex items-start gap-3 rounded-xl px-4 py-3 text-sm ${dark ? "" : ""}`;
  if (loading)
    return (
      <div data-testid={`${testId}-loading`} className={`${base} bg-sand/70 text-fog`}>
        <Loader2 size={16} className="mt-0.5 animate-spin" /> A verificar disponibilidade...
      </div>
    );
  if (error)
    return (
      <div data-testid={`${testId}-error`} className={`${base} bg-red-50 text-red-700`}>
        <Info size={16} className="mt-0.5 shrink-0" /> {error}
      </div>
    );
  if (!quote) return null;
  if (!quote.available)
    return (
      <div data-testid={`${testId}-unavailable`} className={`${base} bg-red-50 text-red-700`}>
        <CircleX size={16} className="mt-0.5 shrink-0" /> Estas datas já estão reservadas. Escolha outras datas.
      </div>
    );
  return (
    <div data-testid={`${testId}-available`} className={`${base} bg-emerald-50 text-emerald-800`}>
      <CircleCheck size={16} className="mt-0.5 shrink-0" />
      <span>
        Datas disponíveis · {quote.nights} {quote.nights === 1 ? "noite" : "noites"} × {euro(quote.price_per_night)} ={" "}
        <strong data-testid={`${testId}-total`} className="font-bold">{euro(quote.total)}</strong>
      </span>
    </div>
  );
};
